import React, { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import CardHeader from '@mui/material/CardHeader';
import { TextField } from '@material-ui/core';
import Alert from '@mui/material/Alert';
import back from '../../../assets/images/back.jpg';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../theme/Theme';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import AirlinesIcon from '@mui/icons-material/Airlines';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

import styled from "styled-components";

import LoginService from '../../api/services/LoginService';

const DivLogin = styled.div`
  background: linear-gradient(135deg, #040138 0%, #0a0a4f 100%);
   min-height: 100vh; /* 👈 chave */ 
   width: 100%; 
   display: flex; 
   flex-direction: column; 
   align-items: center; 
   justify-content:center; 
   padding: 60px 40px; 
   position: relative;  
     &:before { 
        content: "";
         position: absolute; 
         inset: 0; 
         background: url(${back}); 
         background-size: cover; 
         background-position: top center; 
         z-index: 0;
     }
`;

const CardLogin = styled(Card)`
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px !important;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.4) !important;
  margin: 0 auto;
  width: 550px;
  opacity: 0.8;
`;

const Titulo = styled(Typography)`
  z-index: 2;
  color: white;
  font-weight: 600;
  margin-bottom: 30px;
  opacity: 0.8;
  display: flex;
  align-items: center;
  gap: 10px;

  svg {
    color: white;
  }
`;

const ButtonLogin = styled(Button)`
  background: linear-gradient(135deg, #0a0a4f, #2729b4) !important;
  color: white !important;
  font-weight: 600;
  border-radius: 10px !important;
  text-transform: none !important;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(23, 15, 182, 0.5);
    background: linear-gradient(135deg, #2729b4, #0a0a4f) !important;
  }
`;

const CardHeaderLogin = styled(CardHeader)`
  background: transparent !important;

  .MuiCardHeader-title {
    font-size: 1.4rem;
    font-weight: 600;
    letter-spacing: 1px;
  }
`;

const AlertFeedback = styled(Alert)`
    margin-bottom:5px;
    display: ${({ isvisible }) => isvisible === 'true' ? 'flex !important' : 'none !important'}

`

export default function RecuperarSenha() {
    const [email, setEmail] = useState("");
    const [feedback, setFeedback] = useState(false);
    const [variant, setVariant] = useState("error");
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);

    useEffect(() => {
    }, [variant, message, feedback, email]);

    let navigate = useNavigate();

    const servico = new LoginService();

    const goLogin = () => {
        navigate('/login');
    }

    function validarEmail() {
        let retorno = true;
        let message = '';
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

        if (email === '') {
            message += "Preencha o email!\n";
            retorno = false;
        } else {
            if (!emailRegex.test(email)) {
                message += "Email Inválido!\n";
                retorno = false;
            }
        }
        if (!retorno) {
            setMessage(message);
            setFeedback(true);
            setVariant("warning");
        }
        return retorno;
    }

    const resetarSenha = () => {
        setOpen(true);
        setFeedback(false)
        if (validarEmail()) {
            servico.recuperarSenha({
                email: email,
            }).then(response => {
                setFeedback(true);
                setVariant("success");
                setMessage("Senha Resetada! Você receberá um email com a senha provisória!")
            }).catch(erro => {
                setFeedback(true);
                setVariant("error");
                switch (erro?.response?.status) {
                    case 401:
                        setMessage("Usuário não autorizado!")
                        break;
                    case 404:
                        setMessage("Email não encontrado!")
                        break;
                    default:
                        setMessage("Problema ao resetar a senha, entre em contato com o adm do sistema!")
                        break;
                }
            }).finally(() => {
                setOpen(false);
            })
        } else {
            setOpen(false);
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <DivLogin>
                <Titulo variant="h3" gutterBottom>
                    <AirlinesIcon sx={{ fontSize: 50 }}></AirlinesIcon> PORTAL DO AGENTE
                </Titulo>
                <CardLogin>
                    <Card variant="outlined">
                        <CardHeaderLogin title="RECUPERAÇÃO DE SENHA" />
                        <CardContent>
                            <TextField
                                id="email"
                                autoComplete="off"
                                label="Email Cadastrado"
                                type="text"
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                required
                                placeholder="Email"
                                hiddenLabel
                                value={email}
                                onChange={(event) => {
                                    setEmail(event.target.value);
                                }}
                            />
                            <Stack sx={{ width: '100%' }} spacing={2}>
                                <AlertFeedback isvisible={feedback.toString()} variant="filled" severity={variant}>
                                    {message}
                                </AlertFeedback>
                            </Stack>
                            <Grid container spacing={2} style={{ marginTop: 5, marginBotton: '1em' }}>
                                <Grid item xs={6}>
                                    <ButtonLogin onClick={resetarSenha} variant="contained" color="primary">
                                        Enviar
                                    </ButtonLogin>
                                    <ButtonLogin onClick={goLogin} sx={{ marginLeft: 5 }} type="button" variant="contained" color="primary">
                                        Logar
                                    </ButtonLogin>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </CardLogin>
            </DivLogin>
        </ThemeProvider>
    );
}